import * as React from 'react'
import { memo } from 'react'
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={52}
    height={52}
    viewBox="0 0 52 52"
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.5 17.904v-.029a14.625 14.625 0 0 1 24.937-10.37 9.75 9.75 0 0 1 13.927 10.383 3.251 3.251 0 0 1 2.905 3.77c-1.469 8.837-5.102 14.43-10.894 16.783v2.184A4.875 4.875 0 0 1 32.5 45.5h-13a4.875 4.875 0 0 1-4.875-4.875v-2.184C8.834 36.088 5.2 30.495 3.731 21.658a3.25 3.25 0 0 1 2.769-3.75v-.004Zm3.25-.029H13a8.125 8.125 0 1 1 16.25 0h3.25a11.375 11.375 0 1 0-22.75 0Zm6.5 0H26a4.875 4.875 0 1 0-9.75 0Zm22.315 0h3.48A6.515 6.515 0 0 0 35.75 9.75c-.78 0-1.521.137-2.21.387.575.923 1.05 1.918 1.414 2.96a3.257 3.257 0 0 1 3.61 4.778ZM34.125 39h-16.25v1.625A1.625 1.625 0 0 0 19.5 42.25h13a1.625 1.625 0 0 0 1.625-1.625V39Zm-17.394-3.25h18.538c5.154-1.657 8.418-6.344 9.796-14.625H6.934c1.379 8.281 4.641 12.968 9.796 14.625Z"
    />
  </svg>
)
const Memo = memo(SvgComponent)
export default Memo
